import i18n from '@/translation/i18n';

const warehouseData = [
    { header: i18n.t('warehouses.stepper.data'), name: 'supporting-warehouse-data', number: 1 },
    { selector: 'baseInfo', name: i18n.t('warehouses.base_data.title') },
    { selector: 'locationData', name: 'Dane lokalizacji' },
    { selector: 'additionalParameters', name: i18n.t('warehouses.additional_parameters.title') },
    { selector: 'warehouseManager', name: i18n.t('warehouses.warehouse_manager.title_short') },
    { selector: 'additionalNotes', name: i18n.t('warehouses.additional_notes.title') },
    { selector: 'warehouseView', name: i18n.t('warehouses.stepper.view') }
];

export default [warehouseData];
